import styled from 'styled-components';
import { Typography } from '@mui/material';

export const TypographyResend = styled(Typography)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
`;
